import React, { useState } from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

interface ColorPickerModalProps {
    onBack: () => void;
    onColorSelect: (color: string) => void;
}

const ColorPickerModal: React.FC<ColorPickerModalProps> = ({ onBack, onColorSelect }) => {
    const [selectedColor, setSelectedColor] = useState<string | null>(null);
    const colors = [
        '#FF5722', // Orange
        '#9C27B0', // Purple
        '#000000', // Black
        '#FF4081', // Pink
        '#2196F3', // Blue
        '#673AB7', // Deep Purple
        '#FFC107', // Yellow
        '#3E2723', // Brown
        'linear-gradient(to right, #ff7e5f, #feb47b)', // Gradient 1
        'linear-gradient(to right, #6a11cb, #2575fc)', // Gradient 2
    ];

    const handleColorClick = (color: string) => {
        setSelectedColor(color);
        onColorSelect(color);
    };

    return (
        <Box sx={{ width: '100%', flexShrink: 0 }}>
            {/* Header */}
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    mb: 3,
                }}>
                <IconButton onClick={onBack} sx={{ color: 'white' }}>
                    <ArrowBackIcon />
                </IconButton>
                <Typography variant="h6">Select Background</Typography>
                <Box />
            </Box>

            {/* Color Options */}
            <Box
                sx={{
                    display: 'flex',
                    gap: 2,
                    flexWrap: 'wrap',
                    justifyContent: 'center',
                    mb: 3,
                }}>
                {colors.map((color, index) => (
                    <Box
                        key={index}
                        onClick={() => handleColorClick(color)}
                        sx={{
                            width: 40,
                            height: 40,
                            borderRadius: '50%',
                            background: color.startsWith('linear-gradient') ? color : color,
                            cursor: 'pointer',
                            border: '2px solid',
                            borderColor: selectedColor === color ? '#4267B2' : 'transparent',
                        }}
                    />
                ))}
            </Box>

            {/* Preview Section */}
            {selectedColor && (
                <Box
                    sx={{
                        width: '100%',
                        height: 100,
                        background: selectedColor,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        borderRadius: '8px',
                        marginBottom: 3,
                    }}>
                    <Typography sx={{ color: 'white', fontWeight: 'bold' }}>Background Preview</Typography>
                </Box>
            )}
        </Box>
    );
};

export default ColorPickerModal;
